import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { withAlert } from "react-alert";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import ReactDataGrid from "@inovua/reactdatagrid-enterprise";
import "@inovua/reactdatagrid-community/index.css";
import { AddCircleOutline, HelpOutlined as HelpIcon } from "@material-ui/icons";
import SelectEditor from "@inovua/reactdatagrid-community/SelectEditor";
import { connect } from "react-redux";
import BackButton from "../../components/BackButton";
import Group from "../../waybee-ui/Group";
import ClassService from "../../services/ClassService";
import translate from "../../components/DataGrid/translate.json";
import HoverPopover from "../../components/HoverPopover";
import BlockButton from "../../waybee-ui/BlockButton/BlockButton";
import HeaderDetails from "./components/HeaderDetails";
import TestDialog from "./components/TestDialog";
import SimpleDialog from "../../waybee-ui/Dialog/SimpleDialog";
import Dialog from "../../waybee-ui/Dialog";
import DialogTitle from "../../waybee-ui/Dialog/DialogTitle";
import Heading from "../../waybee-ui/Heading";
import DialogContent from "../../waybee-ui/Dialog/DialogContent";
import DialogActions from "../../waybee-ui/Dialog/DialogActions";
import { AbilityContext, Can } from "../../acl/can";
import { createClassAbility as abilityPromisse } from "../../acl/ability";
import fetchGradeJobQueue from "../../utils/fetchGradeJobQueue";

const LoadContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 8px;
`;

const CellText = styled.p`
  color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  ${({ editable }) =>
    !!editable &&
    css`
      margin: 0;
      border: 1px solid rgba(0, 0, 0, 0.25);
      padding: 5px;
      border-radius: 5px;
      min-height: 30px;
    `}
`;
const RollNum = styled.span`
  color: ${({ theme }) => theme.color.primary.main};
  margin-right: 12px;
`;

const Footer = styled(Grid)`
  background-color: white;
  border-right: 1px solid #e4e3e2;
  border-bottom: 1px solid #e4e3e2;
  border-left: 1px solid #e4e3e2;
  display: flex;
  justify-content: end;
  padding: 10px;
`;
const SaveButton = styled(Button)`
  height: 44px;
  font-size: 14px;
  margin-left: 64px;
`;

const SearchButton = styled(Button)`
  width: 100%;
  height: 44px;
  font-size: 14px;
`;

const HelpButton = styled(Button)`
  padding: 0 64px;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.5);
  border-right: 1px solid #ccc;

  p {
    margin: 0 0 0 8px;
    text-transform: capitalize;
  }
`;

const Header = styled(Grid)`
  background-color: white;
  border-right: 1px solid #e4e3e2;
  border-top: 1px solid #e4e3e2;
  border-left: 1px solid #e4e3e2;
  display: flex;
  justify-content: end;
  padding: 10px;
`;

class ClassGradesV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rawData: null,
      dataSource: [],
      columns: [],
      groups: [],
      courses: [],
      periods: [],
      testTypes: [],
      loadingFilters: false,
      loadingTable: false,
      loadingSaveTest: false,
      loadingSaveGrade: false,
      loadingJobs: [],
      loadingPeriods: false,
      loadingMessage: "",
      currentClassString: "",
      processedJobs: [],
      openTestDialog: false,
      openConfirmTest: false,
      openFormula: false,
      filter: {},
      values: {},
      processError: null,
      evaluation: {},
      isEditing: false,
      gridRef: null,
      cellSelection: {},
      aclAbility: null
    };
  }

  async componentDidMount() {
    this.getCourses();
    this.getAcl();
  }

  componentDidUpdate(prevProps) {
    const {
      jobsState: { jobs }
    } = this.props;
    const { filter, loadingJobs, processedJobs } = this.state;
    const currentClass = localStorage.getItem("class");

    if (loadingJobs.length !== 0 && jobs.length >= 1) {
      jobs.forEach((job, index) => {
        const previousJob = prevProps.jobsState.jobs[index];
        const hasProcessed = processedJobs.includes(job.id);

        if (
          !hasProcessed &&
          (job.status === "success" || job.status === "error") &&
          previousJob && job.status !== previousJob.status
        ) {
          const filteredJobs = loadingJobs.filter(
            pendingJob =>
              pendingJob !== currentClass + filter.course.id + filter.period
          );

          if (filteredJobs.length !== loadingJobs.length || !hasProcessed) {
            this.updateJobsProcessedJobs(filteredJobs, job.id);
          }
        }
      });
    }
  }

  getAcl = async () => {
    const { match } = this.props;
    const ability = await abilityPromisse(match.params.id);
    this.setState({ aclAbility: ability });
  };

  getGradePeriods = async idTurmaDisc => {
    const { alert } = this.props;

    try {
      const periods = await ClassService.getGradePeriods(idTurmaDisc);
      if (!periods || !periods.length) {
        this.setState({
          periods: [],
          processError: new Error(
            "Não encontrados períodos para a disciplina selecionada"
          )
        });
        return;
      }

      let currentPeriod = periods.find(period => period.currentPeriod);
      if (!currentPeriod) [currentPeriod] = periods;
      this.setState({ periods });
      this.setFilter("period", currentPeriod.id);
    } catch (e) {
      console.error(e);
      alert.show("Ocorreu um erro ao buscar os períodos", { title: "Erro" });
    } finally {
      this.setState({ loadingFilters: false, loadingPeriods: false });
    }
  };

  getCourses = async () => {
    const { match, alert } = this.props;

    this.setState({ loadingFilters: true });

    const classId = match.params.id;
    try {
      const disciplines = await ClassService.getDisciplines(classId);
      this.setState({ courses: disciplines });
      if (disciplines && disciplines.length) {
        this.setFilter("course", disciplines[0]);
        await this.getGradePeriods(disciplines[0].idTurmaDisc);
      }
    } catch (e) {
      console.error(e);
      alert.show("Ocorreu um erro ao buscar as disciplinas", { title: "Erro" });
    }
  };

  getJobQueue = () => {
    const { jobsState } = this.props;
    const { filter } = this.state;
    const currentClass = localStorage.getItem("class");

    jobsState.jobs.map(job => {
      if (job.status === "pending" && job.classId === currentClass) {
        if (job.course === filter.course.id && job.period === filter.period) {
          this.setState(prevState => ({
            loadingJobs: [
              ...prevState.loadingJobs,
              job.classId + job.course + job.period
            ],
            loadingMessage: `Atribuição de notas da turma ${job.course}, período ${job.period} em andamento.`
          }));
        }
      }
      return null;
    });
  };

  getGrades = async (idTurmaDisc, period) => {
    const { filter } = this.state;
    const currentClass = localStorage.getItem("class");
    const pendingGradeIdentifier =
      currentClass + filter.course.id + filter.period;

    this.setState({
      loadingTable: true,
      currentClassString: pendingGradeIdentifier
    });

    this.getJobQueue();

    const grades = await ClassService.getGradesGridData(idTurmaDisc, period);
    const { groups, students, columns } = grades;

    if (!groups || !students || !columns) {
      alert.show("Não foi encontrado nenhum registro de notas", {
        title: "Nenhum registro encontrado"
      });
    }

    const gradesGroups = groups.map(group => ({
      ...group,
      header: <HeaderDetails title={group.header} />
    }));

    const gradesColumns = grades.columns.map(column => {
      const columnOptions = {
        name: column.id,
        header: column.header,
        group: column.group,
        editable: !!column.editable,
        defaultWidth: 185,
        showColumnMenuTool: false,
        render: ({ value }) => {
          if (column.concepts && value) {
            return (
              <CellText editable={column.editable}>
                {column.concepts.map(c => {
                  if (value === c.id || value.substring(0, 1) === c.id) {
                    return c.label;
                  }
                  return null;
                })}
              </CellText>
            );
          }

          return <CellText editable={column.editable}>{value}</CellText>;
        },
        renderHeader: ({ value }) => (
          <HeaderDetails
            title={value}
            color={column.color}
            hasDetails
            column={column}
            onClick={() => this.getEvaluationInfo(column)}
          />
        )
      };

      if (column.concepts) {
        columnOptions.editor = SelectEditor;
        columnOptions.editorProps = {
          idProperty: "id",
          dataSource: column.concepts,
          collapseOnSelect: true
        };
      }

      return columnOptions;
    });

    const tableEl = document.querySelector(".grades-table");
    gradesColumns.unshift({
      name: "studentId",
      header: "R.A.",
      editable: false,
      locked: true,
      group: "data",
      showColumnMenuTool: false,
      defaultWidth: tableEl ? tableEl.offsetWidth * 0.15 : 150,
      render: ({ value }) => <CellText>{value}</CellText>,
      renderHeader: ({ value }) => <HeaderDetails title={value} />
    });
    gradesColumns.unshift({
      name: "name",
      header: "Aluno",
      editable: false,
      locked: true,
      sortable: true,
      group: "data",
      showColumnMenuLockOptions: false,
      showColumnMenuGroupOptions: false,
      showColumnMenuFilterOptions: false,
      defaultWidth: tableEl ? tableEl.offsetWidth * 0.35 : 350,
      render: ({ value, data }) => (
        <HoverPopover key={data.id} id={data.id} value={value}>
          <CellText>
            <RollNum>{data.rollCallNum}</RollNum>
            {value}
          </CellText>
        </HoverPopover>
      ),
      renderHeader: ({ value }) => <HeaderDetails title={value} />
    });

    this.setState({
      rawData: grades,
      columns: gradesColumns,
      dataSource: grades.students,
      testTypes: grades.testTypes,
      groups: gradesGroups,
      loadingTable: false
    });
  };

  getEvaluationInfo = async column => {
    const { IDTURMADISC, CODETAPA, CODPROVA } = column;

    this.setState({
      loadingSaveGrade: true,
      isEditing: true
    });
    try {
      const evaluationData = await ClassService.getGradeEvaluation(
        IDTURMADISC,
        CODETAPA,
        CODPROVA
      );
      this.setState({ evaluation: evaluationData });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({
        loadingSaveGrade: false,
        openTestDialog: true
      });
    }
  };

  setFilter(field, value) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        [field]: value
      }
    });
  }

  updateJobsProcessedJobs = (filteredLoadingJobs, jobId) => {
    const { filter } = this.state;
    this.setState(
      prev => ({
        loadingJobs: filteredLoadingJobs,
        loadingMessage: "",
        processedJobs: [...prev.processedJobs, jobId]
      }),
      () => this.getGrades(filter.course.idTurmaDisc, filter.period)
    );
  };

  handleOnDeleteEvaluation = async () => {
    const { alert } = this.props;
    const { filter, evaluation } = this.state;
    const {
      IDTURMADISC,
      CODETAPA,
      CODPROVA,
      TIPOETAPA
    } = evaluation.SProvasCompl;

    const data = {
      idTurmaDisc: IDTURMADISC,
      codEtapa: CODETAPA,
      codProva: CODPROVA,
      tipoEtapa: TIPOETAPA
    };

    this.setState({
      loadingSaveTest: true,
      openConfirmTest: true,
      openTestDialog: false
    });

    try {
      await ClassService.deleteGradeEvaluations(data);
      this.getGrades(filter.course.idTurmaDisc, filter.period);
      alert.show("Avaliação alterada com sucesso", { title: "Sucesso" });
      this.setState({ loadingSaveTest: false });
    } catch (e) {
      console.error(e);
      alert.show("Ocorreu um erro ao alterar avaliação", { title: "Erro" });
    } finally {
      this.setState({
        openConfirmTest: false,
        loadingSaveTest: false,
        loadingTable: true
      });
    }
  };

  onEditComplete = ({ value, columnId, rowIndex, data }) => {
    const { alert } = this.props;
    const {
      dataSource,
      values,
      filter,
      rawData: { columns }
    } = this.state;

    const isInputValid = /^[\d.,]*$/.test(value);
    const columnData = columns.find(column => column.id === columnId);

    if (
      value !== null &&
      isInputValid &&
      parseFloat(columnData.value) < parseFloat(value)
    ) {
      return alert.show(
        "O valor digitado não pode ser maior que o valor máximo da avaliação.",
        { title: "Erro na digitação da nota" }
      );
    }

    const storedData = [...dataSource];
    storedData[rowIndex] = { ...storedData[rowIndex], [columnId]: value };

    const gradeObj = {
      idExam: columnData.CODPROVA,
      idStep: columnData.CODETAPA,
      idTurmaDisc: data.idturmadisc || filter.course.idTurmaDisc,
      studentId: data.studentId,
      value: value || " "
    };
    values[`${data.studentId}-${columnId}`] = gradeObj;

    return this.setState({ dataSource: storedData, values });
  };

  changeCourse = e => {
    this.setState({ loadingPeriods: true });

    this.setFilter("course", e.target.value);
    this.getGradePeriods(e.target.value.idTurmaDisc);
  };

  changePeriod = e => {
    this.setFilter("period", e.target.value);
  };

  searchGradesFilter = async () => {
    const { filter } = this.state;

    this.setState({ processError: null });
    this.getGrades(filter.course.idTurmaDisc, filter.period);
  };

  saveGrades = async () => {
    const { alert, match } = this.props;
    const { values, filter } = this.state;
    const currentClass = localStorage.getItem("class");
    const grades = Object.values(values);
    const classId = match.params.id;

    if (!grades.length) {
      return alert.show(
        "Não houve nenhuma alteração na grade de notas, efetue alguma alteração e tente novamente",
        { title: "Nenhuma nota alterada" }
      );
    }

    this.setState({ loadingSaveGrade: true });

    try {
      await ClassService.saveGradesV2({ filter, grades, classId });
      alert.show(
        "Estamos processando sua solicitação e em breve estará concluída",
        { title: "Notas enviadas" }
      );
      this.setState(
        prevState => ({
          loadingJobs: [
            ...prevState.loadingJobs,
            currentClass + filter.course.id + filter.period
          ],
          loadingMessage: `Atribuição de notas da turma ${filter.course.id}, período ${filter.period} em andamento.`,
          values: {}
        }),
        await fetchGradeJobQueue()
      );
      this.getGrades(filter.course.idTurmaDisc, filter.period);
    } catch (e) {
      console.error(e);
      if (!e.message.includes("timeout")) {
        alert.show(`Ocorreu um erro ao salvar as notas ${e}`, {
          title: "Erro"
        });
      }
    } finally {
      this.setState({ loadingSaveGrade: false });
    }

    return null;
  };

  saveTest = async data => {
    const { alert } = this.props;
    const { filter } = this.state;

    this.setState({
      loadingSaveTest: true,
      openConfirmTest: true,
      openTestDialog: false
    });

    try {
      await ClassService.saveTest({
        idTurmaDisc: filter.course.idTurmaDisc,
        period: filter.period,
        fields: data
      });
      this.setState({ loadingSaveTest: false });
      this.getGrades(filter.course.idTurmaDisc, filter.period);
    } catch (e) {
      console.error(e);
      this.setState({ loadingSaveTest: false, openConfirmTest: false });
      alert.show("Ocorreu um erro ao salvar as disciplinas", { title: "Erro" });
    }
  };

  scrollTo = index => {
    const { gridRef, columns } = this.state;
    const columnId = parseInt(Object.keys(index)[0].split(",")[1], 10);
    const scrollTo = columnId + 4;

    if (scrollTo <= columns.length) {
      gridRef.current.scrollToColumn(scrollTo, { duration: 100 });
    }
  };

  render() {
    const { history } = this.props;
    const {
      columns,
      groups,
      dataSource,
      courses,
      testTypes,
      loadingFilters,
      loadingTable,
      loadingSaveTest,
      loadingSaveGrade,
      loadingJobs,
      loadingPeriods,
      loadingMessage,
      currentClassString,
      openTestDialog,
      openConfirmTest,
      openFormula,
      filter,
      periods,
      processError,
      isEditing,
      evaluation,
      cellSelection,
      aclAbility,
      rawData
    } = this.state;

    const formula = periods.find(period => period.id === filter.period)
      ?.formula;

    const scrolProps = {
      ...ReactDataGrid.defaultProps.scrollProps,
      autoHide: false,
      scrollThumbWidth: 15,
      scrollThumbOverWidth: 20
    };

    const menu = menuProps => {
      menuProps.items.splice(-2, 2);
    };

    const isGradesAvailable =
      loadingJobs.length >= 0 &&
      loadingJobs.some(job => job === currentClassString);
    const isFilterAvailable =
      !isGradesAvailable &&
      (loadingTable || loadingSaveTest || loadingSaveGrade);
    const fallbackMessageOnFirstLoad =
      'Selecione os filtros acima e clique em "buscar" para ver a grade de notas.';

    if (!aclAbility) return null;
    return (
      <AbilityContext.Provider value={aclAbility}>
        <Grid container spacing={2}>
          <BackButton onClick={history.goBack} />
          <Can I="use module" a="ADD_TEST">
            {!loadingFilters && !filter?.course?.mother && (
              <Grid item xs={12}>
                <BlockButton
                  startIcon={<AddCircleOutline />}
                  onClick={() =>
                    this.setState({ openTestDialog: true, isEditing: false })}
                >
                  ADICIONAR AVALIAÇÃO
                </BlockButton>
              </Grid>
            )}
          </Can>
          <Grid item xs={12}>
            <Group fullWidth>
              {loadingFilters ? (
                <LoadContainer>
                  <CircularProgress />
                </LoadContainer>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel id="filter-course-label">
                        Disciplina
                      </InputLabel>
                      <Select
                        fullWidth
                        labelId="filter-course-label"
                        value={filter.course}
                        onChange={this.changeCourse}
                        disabled={isFilterAvailable}
                      >
                        {courses.map(course => (
                          <MenuItem value={course}>{course.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl fullWidth>
                      <InputLabel id="filter-course-label">Período</InputLabel>
                      <Select
                        fullWidth
                        onChange={this.changePeriod}
                        value={filter.period}
                        disabled={isFilterAvailable || loadingPeriods}
                      >
                        {periods.map(period => (
                          <MenuItem value={period.id}>{period.name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <SearchButton
                      variant="contained"
                      color="primary"
                      onClick={this.searchGradesFilter}
                      disabled={isFilterAvailable || loadingPeriods}
                    >
                      Buscar
                    </SearchButton>
                  </Grid>
                </Grid>
              )}
            </Group>
          </Grid>

          {!loadingFilters && processError && (
            <Grid item xs={12}>
              <Group fullWidth>{processError.message}</Group>
            </Grid>
          )}

          {!loadingFilters && !processError && (
            <Grid item xs={12}>
              {loadingTable || isGradesAvailable ? (
                <LoadContainer>
                  {isGradesAvailable ? (
                    <>
                      <Typography
                        color="textSecondary"
                        variant="h6"
                        style={{ padding: "15px" }}
                      >
                        {loadingMessage}
                      </Typography>
                      <CircularProgress />
                      <Typography
                        color="textSecondary"
                        variant="h4"
                        style={{ padding: "15px" }}
                      >
                        Retorne quando finalizadas
                      </Typography>
                    </>
                  ) : (
                    <CircularProgress />
                  )}
                </LoadContainer>
              ) : (
                <>
                  {!rawData ? (
                    <LoadContainer>
                      <Typography
                        color="textSecondary"
                        variant="h4"
                        style={{ padding: "15px" }}
                      >
                        {fallbackMessageOnFirstLoad}
                      </Typography>
                    </LoadContainer>
                  ) : (
                    <>
                      <Header item xs={12}>
                        <SaveButton
                          variant="contained"
                          color="primary"
                          onClick={this.saveGrades}
                        >
                          Salvar alterações
                        </SaveButton>
                      </Header>
                      <ReactDataGrid
                        licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
                        className="grades-table"
                        idProperty="studentId"
                        onReady={e => this.setState({ gridRef: e })}
                        columns={columns}
                        groups={groups}
                        dataSource={dataSource}
                        onEditComplete={this.onEditComplete}
                        renderColumnContextMenu={menuProps => menu(menuProps)}
                        resizable
                        editable
                        sortable={false}
                        enableSelection={false}
                        rowHeight={50}
                        style={{ minHeight: 550 }}
                        scrollProps={scrolProps}
                        i18n={translate.i18n}
                        multiSelect={false}
                        cellSelection={cellSelection}
                        onCellSelectionChange={e => this.scrollTo(e)}
                        showColumnMenuToolOnHover={false}
                        enableColumnAutosize
                      />

                      <Footer item xs={12}>
                        {formula && (
                          <HelpButton
                            onClick={() => this.setState({ openFormula: true })}
                          >
                            <HelpIcon />
                            <p>Cálculo de média</p>
                          </HelpButton>
                        )}
                        <SaveButton
                          variant="contained"
                          color="primary"
                          onClick={this.saveGrades}
                        >
                          Salvar alterações
                        </SaveButton>
                      </Footer>
                    </>
                  )}
                </>
              )}
            </Grid>
          )}
        </Grid>

        {openTestDialog &&
          (!isEditing || (!loadingSaveGrade && evaluation)) && (
            <TestDialog
              open={openTestDialog}
              testTypes={testTypes}
              onSave={this.saveTest}
              onDelete={this.handleOnDeleteEvaluation}
              onClose={() => this.setState({ openTestDialog: false })}
              isEditing={isEditing}
              evaluation={evaluation}
            />
          )}

        <Dialog
          open={openConfirmTest}
          size="sm"
          fullWidth
          onClose={() => this.setState({ openConfirmTest: false })}
        >
          {isEditing ? (
            <DialogTitle>
              {loadingSaveTest ? "Alterando avaliação" : "Avaliação alterada"}
            </DialogTitle>
          ) : (
            <DialogTitle>
              {loadingSaveTest ? "Salvando Avaliações" : "Nova Avaliação"}
            </DialogTitle>
          )}
          {!loadingSaveTest ? (
            <>
              <DialogContent>
                <Heading>
                  {isEditing
                    ? "Avaliação criada com editada!"
                    : "Avaliação criada com sucesso!"}
                </Heading>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({ openConfirmTest: false })}
                >
                  Ok
                </Button>
              </DialogActions>
            </>
          ) : (
            <LoadContainer>
              <CircularProgress />
            </LoadContainer>
          )}
        </Dialog>

        <SimpleDialog
          open={loadingSaveGrade}
          onClose={() => this.setState({ loadingSaveGrade: false })}
          title={isEditing ? "Editar Avaliação" : "Salvando"}
          loading
        />

        <SimpleDialog
          open={openFormula}
          closeBtn
          onClose={() => this.setState({ openFormula: false })}
          title="Fórmula de calculo"
          message={formula}
        />
      </AbilityContext.Provider>
    );
  }
}

ClassGradesV2.propTypes = {
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.any
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.any
    })
  }).isRequired,
  jobsState: PropTypes.arrayOf(PropTypes.shape()).isRequired // injected by react-redux mapStateToProps connect()
};

const mapStateToProps = state => ({
  jobsState: state.jobsState
});

export default connect(mapStateToProps)(withAlert()(withRouter(ClassGradesV2)));
